import { useApolloClient } from '@apollo/client'
import { EmployeeWorkplacesFilterDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export type NumberInFilter = {
  type: 'in'
  label: string
  options: {
    cache?: boolean
    options:
      | Array<{ label: string; value: number }>
      | (() => Promise<Array<{ label: string; value: number }>>)
  }
}

export const useWorkplaceFilter = (): NumberInFilter => {
  const client = useApolloClient()

  return {
    label: i18n.t('employees.employees_list.headers.workplace'),
    type: 'in' as const,
    options: {
      cache: true,
      options: async () => {
        const { data } = await client.query({
          query: EmployeeWorkplacesFilterDocument,
          fetchPolicy: 'cache-first',
        })

        return data.locations.locations.map((location) => ({
          label: location.name,
          value: location.id,
        }))
      },
    },
  }
}
